"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedOrigins = void 0;
exports.allowedOrigins = [
    "http://americanhighschool.org",
    "https://americanhighschool.org",
    "http://www.americanhighschool.org",
    "https://www.americanhighschool.org",
    "https://www.americanhighschool.org/"
];
